import React, { useMemo } from 'react';
import ButtonWithIcon from 'react/components/ButtonWithIcon/ButtonWithIcon';
import { actionCreators } from 'react/api/actions/chatTicketActions';

import { getResourceTo } from 'react/utils/chatUtils';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import finishAttendance from 'static/images/chat/finishAttendance.svg';
import attendanceDetails from 'static/images/chat/attendanceDetails.svg';
import reasignAttendance from 'static/images/chat/reasignAttendance.svg';
// TODO: In GBP-623 Finish the create task with linkedTicket after backend be done
// import attendanceTask from 'static/images/chat/attendanceTask.svg';

const buttonStyle = {
  base: {
    borderRadius: '3.5px',
    border: '1px solid #4ABA71',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '60px',
    paddingTop: '4px'
  },
  icon: {
    width: '20px',
    height: '20px'
  },
  label: {
    color: '#4ABA71',
    textTransform: 'uppercase',
    fontSize: '10px',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 600
  }
};

function ActionButtons({
  ticket,
  toggleChatWindow,
  toggleFinishCallModal,
  toggleReassignCallModal
}) {
  const ticketIsClosed = useMemo(() => ticket.get('status') === 'CLOSED',
    [ticket.get('status')]);

  function redirectTo(url) {
    window.location.href = url;

    toggleChatWindow();
  }

  // TODO: In GBP-623 Finish the create task with linkedTicket after backend be done
  // function redirectToTask(url) {
  //   App.Forms.Task.dataFromTicket = {
  //     ticketId: ticket.get('ticketId')
  //   };

  //   redirectTo(url);
  // }

  return (
    <div className="actions">
      {
        !ticketIsClosed && (
          <ButtonWithIcon
            className="actions-item"
            label={getResourceTo('Greenmile.Chat.TicketActions.FinishCall')}
            styles={buttonStyle}
            onClick={() => toggleFinishCallModal(ticket)}
          >
            <img src={finishAttendance} alt="Finish attendance icon" />
          </ButtonWithIcon>
        )
      }
      <ButtonWithIcon
        className="actions-item"
        label={getResourceTo('Greenmile.Chat.TicketActions.CallDetails')}
        styles={buttonStyle}
        onClick={() => redirectTo(`/#/ticket/details/${ticket.get('ticketId')}`)}
      >
        <img src={attendanceDetails} alt="Attendance details icon" />
      </ButtonWithIcon>
      {
        !ticketIsClosed && (
          <ButtonWithIcon
            className="actions-item"
            label={getResourceTo('Greenmile.Chat.TicketActions.ReasignCall')}
            styles={buttonStyle}
            onClick={() => toggleReassignCallModal(ticket)}
          >
            <img src={reasignAttendance} alt="Reasign attendance icon" />
          </ButtonWithIcon>
        )
      }
      {/*
        // TODO: In GBP-623 Finish the create task with linkedTicket after backend be done
        <ButtonWithIcon
          className="actions-item"
          label={getResourceTo('Greenmile.Chat.TicketActions.CallTask')}
          styles={buttonStyle}
          onClick={() => redirectToTask('/#/Task/new')}
        >
          <img src={attendanceTask} alt="Attendance task icon" />
        </ButtonWithIcon>
        */
      }
    </div>
  );
}

ActionButtons.propTypes = {
  ticket: PropTypes.object.isRequired,
  toggleChatWindow: PropTypes.func.isRequired,
  toggleFinishCallModal: PropTypes.func.isRequired,
  toggleReassignCallModal: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  toggleFinishCallModal: actionCreators.toggleFinishCallModal,
  toggleReassignCallModal: actionCreators.toggleReassignCallModal
};

export default connect(null, mapDispatchToProps)(ActionButtons);
